var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_9)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5867 36.8884C25.1867 36.8001 18.3851 35.8601 11.2617 28.7384C4.14008 21.6151 3.20175 14.8151 3.11175 12.4134C2.97841 8.75345 5.78175 5.19845 9.02008 3.81012C9.41004 3.64173 9.83708 3.57762 10.2593 3.62407C10.6815 3.67053 11.0844 3.82596 11.4284 4.07511C14.0951 6.01845 15.9351 8.95845 17.5151 11.2701C17.8627 11.778 18.0114 12.396 17.9327 13.0064C17.854 13.6169 17.5535 14.177 17.0884 14.5801L13.8367 16.9951C13.6797 17.1086 13.5691 17.2752 13.5255 17.464C13.482 17.6528 13.5085 17.851 13.6001 18.0218C14.3367 19.3601 15.6467 21.3534 17.1467 22.8534C18.6484 24.3534 20.7351 25.7501 22.1667 26.5701C22.3463 26.6709 22.5575 26.699 22.7572 26.6488C22.9568 26.5986 23.1296 26.4738 23.2401 26.3001L25.3567 23.0784C25.7459 22.5615 26.32 22.2152 26.9587 22.1121C27.5975 22.0089 28.2513 22.1569 28.7834 22.5251C31.1284 24.1484 33.8651 25.9568 35.8684 28.5218C36.1378 28.8683 36.3091 29.2808 36.3646 29.7162C36.42 30.1516 36.3574 30.5938 36.1834 30.9968C34.7884 34.2518 31.2584 37.0234 27.5867 36.8884Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1f23b241408bc10c40c020f122361e59.svg";
export { ForwardRef as ReactComponent };